module.exports = __webpack_public_path__ + "static/media/tokiwa10-1.b6c52c42.jpg";